export const CURRENCIES: {
    [key: string]: string,
} = {
    JPY: 'JPY',
    CNY: 'CNY',
};

/**
 * Return a boolean indicating that the order of currency value should be displayed in millions
 * @param userCurrencyCode - currency code
 * @returns {boolean}
 */
export const inMillion = (userCurrencyCode: string): boolean =>
    [CURRENCIES.JPY, CURRENCIES.CNY].includes(userCurrencyCode);
